/** localStorage can throw in private windows or when blocked; treat it as optional everywhere. */
export function safeStorage(): Storage | undefined {
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}
